import Vue from 'vue';
import VueRouter from 'vue-router';
import core from '@/core';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [],
});

router.beforeEach((to, from, next) => {
  core.template.menu.setShowDefault();
  next();
});

export default router;
